import React from "react";
import { Link } from "react-router-dom";
import { cipcAutomationFeatures } from "../data/octoberRelease";

export default function CipcAutomationFeatures({ darkMode = false }) {
  return (
    <section
      aria-label="CIPC automation features"
      style={{
        maxWidth: "1200px",
        margin: "32px auto",
        padding: "clamp(20px, 4vw, 36px)",
        borderRadius: "20px",
        backgroundColor: darkMode ? "#172554" : "#eff6ff",
        border: `1px solid ${darkMode ? "#3b82f6" : "#bfdbfe"}`,
        color: darkMode ? "#e2e8f0" : "#1e293b",
        textAlign: "left",
      }}
    >
      <h2 style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)", fontWeight: 700 }}>
        CIPC automation for your practice
      </h2>
      <p style={{ lineHeight: 1.7 }}>
        Keep annual returns and beneficial ownership moving with automated client
        communication and a shared filing desk in Compliance → CIPC Automation.
      </p>
      <ul style={{ paddingLeft: "22px", lineHeight: 1.7 }}>
        {cipcAutomationFeatures.map((feature) => <li key={feature}>{feature}</li>)}
      </ul>
      <p style={{ lineHeight: 1.7 }}>
        Your team submits filings through CIPC and records the outcome in
        FilingStack. Marking Billed tracks progress; create the invoice separately.
        CIPC filing fees and your practice’s service fees are separate from
        software subscription charges. Automated emails require setup and activation.
      </p>
      <Link to="/UsageInfo#2" style={{ color: darkMode ? "#93c5fd" : "#1d4ed8", fontWeight: 600 }}>
        Read the CIPC automation guide →
      </Link>
    </section>
  );
}
